<template>
  <div>
    <PageName title="Информация о билетах" />

    <div class="page">
      <div class="page__block">
        <h3>Пассажиры:</h3>
        <div v-if="!orderLoading" class="passengers scroll">
          <div
            v-for="(user, i) in users"
            :key="i + 'account'"
            :class="['passengers__item', { active: currentUser === user }]"
            @click.capture="setUser(user, i)"
          >
            <AccountBadge :user="user" />
            <span v-if="false" class="user_return-ticket">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.85314 1.86057L1.5 0L0 5.5H5.5L4.02931 3.47781C4.8599 2.86333 5.88754 2.49999 7.00004 2.49999C9.76147 2.49999 12 4.73857 12 7.49999C12 10.2614 9.76147 12.5 7.00004 12.5C4.96299 12.5 3.21045 11.2818 2.43118 9.53419L0.605225 10.3472C1.24475 11.7836 2.34925 12.9628 3.74074 13.6949C5.13223 14.427 6.72969 14.6693 8.27569 14.3828C9.82169 14.0963 11.2262 13.2976 12.2629 12.1154C13.2996 10.9333 13.9082 9.43653 13.9905 7.86636C14.0727 6.29618 13.624 4.74402 12.7165 3.45999C11.8091 2.17595 10.4957 1.23483 8.98815 0.788264C7.48057 0.341697 5.86654 0.415695 4.40614 0.998334C3.85028 1.2201 3.32899 1.51064 2.85314 1.86057Z"
                  fill="#97B2C4"
                />
              </svg>
            </span>
            <Button
              v-if="false"
              width="134px"
              height="32px"
              :text="!user.all_tickets ? 'Регистрация' : 'Билет'"
              :class="[
                {
                  'btn-secondary': !user.all_tickets,
                  'btn-success': user.all_tickets,
                },
                'success-icon',
              ]"
              style="font-size: 14px"
              :icon="user.all_tickets ? 'mark' : null"
              iconWidth="15px"
            />
          </div>
        </div>

        <Preloader v-else style="height: auto" />
      </div>

      <div class="page__block page__block--tickets" style="margin-left: 20px">
        <h3>Билеты:</h3>

        <div class="points__panel">
          <div class="points__panel-block">
            <div
              v-for="(point, i) in points"
              v-show="i + 1 >= leftPageNumber && i + 1 <= rightPageNumber"
              :key="i + 'points'"
              :class="[
                'points__panel-item',
                { active: point === currentPoint },
              ]"
              @click="setPoint(point, i)"
            >
              {{
                point.sort !== 1
                  ? "С пересадкой"
                  : point.direction
                  ? "Обратно"
                  : "Туда"
              }}
            </div>
          </div>

          <div class="points__panel-block">
            <svgicon
              @click="portionNumber !== 1 ? (portionNumber -= 1) : null"
              icon="middle_arrow"
              :class="['points__panel-icon', { active: portionNumber !== 1 }]"
              width="10px"
            />
            <svgicon
              @click="
                portionCount !== portionNumber ? (portionNumber += 1) : null
              "
              icon="middle_arrow"
              :class="[
                'points__panel-icon',
                {
                  active: portionCount !== portionNumber,
                },
              ]"
              width="10px"
            />
          </div>
        </div>

        <div class="row">
          <span
            @click="historyDialog = true"
            class="ticket-log__link"
            v-if="getHistory"
          >
            <span class="ticket-log__icon">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.85312 2.11063L1.49998 0.250061L-2.28882e-05 5.75006H5.49998L4.02929 3.72787C4.85988 3.11339 5.88752 2.75005 7.00002 2.75005C9.76145 2.75005 12 4.98863 12 7.75005C12 10.5115 9.76145 12.7501 7.00002 12.7501C4.96296 12.7501 3.21043 11.5319 2.43116 9.78425L0.605202 10.5972C1.24473 12.0336 2.34922 13.2129 3.74072 13.945C5.13221 14.6771 6.72966 14.9194 8.27567 14.6328C9.82167 14.3463 11.2262 13.5476 12.2629 12.3655C13.2996 11.1833 13.9081 9.68659 13.9904 8.11642C14.0727 6.54624 13.624 4.99408 12.7165 3.71005C11.809 2.42602 10.4957 1.48489 8.98813 1.03832C7.48055 0.591758 5.86652 0.665756 4.40612 1.24839C3.85025 1.47016 3.32897 1.76071 2.85312 2.11063Z"
                  fill="#006FBA"
                />
              </svg>
            </span>
            Журнал билетов
          </span>
          <div :class="['status', statusTicket.type]">
            {{ statusTicket.name || "" }}
          </div>
        </div>

        <div class="points__way">
          <span
            >Откуда:
            <span class="points__way-town">{{
              currentPoint ? currentPoint.name : "-"
            }}</span></span
          >
          <svgicon icon="big_arrow" width="15px" class="points__way-icon" />
          <span
            >Куда:
            <span class="points__way-town">{{
              currentPoint ? currentPoint.nameTo : "-"
            }}</span>
          </span>
        </div>

        <Form
          v-show="!pointsDataLoading"
          v-model="formData"
          ref="formData"
          class="ticket__form"
          scrollWhenInvalid
        >
          <VSelect
            placeholder="Статья расходов"
            name="expense"
            :items="expenseOptions"
            item-text="name"
            disabled
          />

          <VSelect
            placeholder="Вид транспорта"
            name="transport"
            item-text="name"
            :items="transportOptions"
            disabled
          />

          <VSelect
            placeholder="Карта лояльности"
            name="loyaltyCard"
            item-text="card_number"
            :items="cardOptions"
          />

          <div class="col-2 double-fields">
            <VInput
              type="copy"
              name="flightNumber"
              placeholder="№ рейса"
              :disabled="!currentUser"
              @copy="openCopyModal()"
            />
            <VInput
              name="ticketNumber"
              placeholder="№ билета"
              :disabled="!currentUser"
            />
          </div>

          <div class="col-2 double-fields">
            <VInput
              placeholder="Стоимость билета"
              name="cost"
              type="currency"
              pattern="^[0-9]+(,|\.)?[0-9]{0,2}$"
              :disabled="!currentUser"
            />

            <VInput
              placeholder="НДС"
              name="tax"
              type="currency"
              pattern="^[0-9]+(,|\.)?[0-9]{0,2}$"
              :disabled="!currentUser"
            />
          </div>

          <VInput
            placeholder="Сумма штрафа"
            name="penalty"
            type="currency"
            pattern="^[0-9]+(,|\.)?[0-9]{0,2}$"
            :disabled="!currentUser"
          />

          <div class="col-2 double-fields">
            <VInput
              type="date"
              placeholder="Дата отправления"
              :required="!!formData.departureTime"
              name="departureDate"
              :disabled="!currentUser"
              @blur="
                checkValidDate(
                  !formData.departureDate && !!formData.departureTime
                )
              "
            />
            <VInput
              type="date"
              onlyTime
              placeholder="Время"
              name="departureTime"
              :disabled="!currentUser"
            />
          </div>

          <div class="col-2 double-fields">
            <VInput
              type="date"
              placeholder="Дата прибытия"
              name="arrivalDate"
              :required="!!formData.arrivalTime"
              :disabled="!currentUser"
              :minDate="formData.departureDate"
              @blur="
                checkValidDate(!formData.arrivalDate && !!formData.arrivalTime)
              "
            />
            <VInput
              type="date"
              onlyTime
              placeholder="Время"
              name="arrivalTime"
              :disabled="!currentUser"
              :minDate="
                formData.departureDate === formData.arrivalDate
                  ? formData.departureTime
                  : null
              "
            />
          </div>

          <VInput name="ticketId" v-show="false" />

          <div class="ticket__form-file">
            <transition-group name="fade" v-if="allTickets[currentPointIndex]">
              <div style="display: flex" v-for="(file, i) in files" :key="i">
                <VFile :value="file" />
                <svgicon
                  @click="removeFile(file, i)"
                  width="18px"
                  icon="clear"
                  class="clear-icon"
                  style="margin-left: 15px"
                />
              </div>
            </transition-group>

            <img
              v-show="fileLoading"
              src="/img/Loader.gif"
              style="max-width: 50px; max-height: 25px; margin-left: 20px"
            />
          </div>

          <VFileField
            @upload="uploadTicket"
            v-if="currentUser"
            accept="image/*,.pdf"
          />
        </Form>

        <Preloader v-if="pointsDataLoading" style="height: auto" />
      </div>

      <div style="margin-left: 15px">
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          text="Сохранить"
          :disabled="!isValid"
          class="btn-primary"
          style="margin-bottom: 12px"
          @click="saveAllChanges"
        />
        <Button
          @click="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin-top: 12px"
        />
        <Button
          :loading="returnLoading"
          @click="openReturnOrderModal('exchange')"
          width="100%"
          height="48px"
          text="Обмен"
          style="margin-top: 32px"
          class="btn-outline-primary"
          dark
          :disabled="
            allTickets[currentPointIndex] &&
            allTickets[currentPointIndex].ticket_statuses_id !== 2
          "
        />
        <Button
          :loading="returnLoading"
          @click="openReturnOrderModal('return')"
          width="100%"
          height="48px"
          text="Возврат"
          style="margin-top: 12px"
          class="btn-outline-primary"
          dark
          :disabled="
            allTickets[currentPointIndex] &&
            allTickets[currentPointIndex].ticket_statuses_id !== 2
          "
        />
      </div>
    </div>

    <Modal
      v-if="commentDialog.isActive"
      @close="commentDialog.isActive = false"
      width="400px"
    >
      <Form @request="commentDialog.submit">
        <h2 style="margin-bottom: 24px">{{ commentDialog.title }}</h2>
        <!-- <VSelect
          placeholder="Пассажиры"
          name="passengersFIO"
          :items="users"
          :value="passengerReturn"
          @change="selectPassengerReturn"
          withCheckbox
          multiple
          style="margin-bottom: 24px"
          class="return_pas"
          multiModels
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" fullUserinfo />
          </template>
        </VSelect> -->
        <!-- <VSelect
              placeholder="Маршруты"
              required
              name="routs"
              :items="getRouts"
              :value="routsReturn"
              @change="selectRoutsReturn"
              withCheckbox
              multiple
              style="margin-bottom: 24px"
          >
            <template slot="item" slot-scope="{ item }">
              <span>{{item.name}}</span>
            </template>
          </VSelect> -->
        <!-- <VSelect
            placeholder="Pуководитель"
            name="leadFIO"
            :value="leadReturn"
            :items="leadersExist"
            searchSelect
            leader
            required
            style="margin-bottom: 24px"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge
                :user="item"
                fullUserinfo
                :style="isRead ? 'margin-top: 19px' : null"
            />
          </template>
        </VSelect> -->
        <VInput
          required
          name="comment"
          type="textarea"
          placeholder="Причина"
          style="margin-bottom: 24px"
        />
        <Button
          width="100%"
          height="48px"
          text="Отправить"
          class="btn-primary"
          style="margin-bottom: 16px"
        />
        <Button
          width="100%"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          @click.native.prevent="commentDialog.isActive = false"
        />
      </Form>
    </Modal>

    <!-- Журнал изменений заявки -->
    <HistoryTickets
      v-if="historyDialog"
      @close="historyDialog = false"
      @loading="historyLoading = !historyLoading"
      :orderId="orderId"
      :ticket="allTickets[currentPointIndex].history"
    />

    <Modal v-if="isError" @close="isError = false" width="544px" height="174px">
      <h2 class="center">
        Заполните информацию по билету, или прикрепите файл
      </h2>
    </Modal>

    <Modal v-if="isCopy" @close="isCopy = false" width="500px">
      <h2 class="center" style="margin-bottom: 24px">
        Копировать информацию по билету
      </h2>
      <Form v-model="copyDate" @request="copyNumberFlights()">
        <VSelect
          placeholder="Пассажиры"
          required
          name="passengersCopy"
          :items="usersCopy"
          withCheckbox
          multiple
          style="margin-bottom: 24px"
          class="return_pas"
          multiModels
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" fullUserinfo />
          </template>
        </VSelect>
        <Button
          :loading="copyLoading"
          width="100%"
          height="48px"
          text="Копировать"
          class="btn-primary"
          style="margin-bottom: 16px"
        />
        <Button
          width="100%"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          @click.native.prevent="isCopy = false"
        />
      </Form>
    </Modal>
  </div>
</template>

<script>
import PageName from "@/components/PageName.vue";
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Button from "@/components/Button.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import VFile from "@/components/VFile.vue";
import VFileField from "@/components/VFiledrop.vue";
import Preloader from "@/components/Preloader.vue";
import VSelect from "@/components/Form/VSelect";
import Modal from "@/components/Modals/Modal";
import HistoryTickets from "@/views/Orders/HistoryTickets.vue";

import {
  CreateTicket,
  UpdateTicket,
  AddTicketFile,
  getTicketInfo,
  getAllTicketsInfo,
  removeFile,
  setStatusReturn,
  getOrderTicketsInfo,
  copyNumberFlights,
} from "@/api/files";

import { getUserCard } from "@/api/cards";
import {
  parseDate,
  simpleDate,
  onlyTime,
  simpleDate as convertDate,
} from "@/utils/filters/dateFilters";
import { mapState } from "vuex";

class Point {
  constructor(
    ticketStatusesId = null,
    expense = null,
    transport = null,
    loyaltyCard = null,
    flightNumber = "",
    ticketNumber = "",
    cost = "",
    departureDate = "",
    departureTime = "",
    arrivalDate = "",
    arrivalTime = "",
    tax = "",
    penalty = "",
    ticketId
  ) {
    this.ticketStatusesId = ticketStatusesId;
    this.expense = expense;
    this.transport = transport;
    this.loyaltyCard = loyaltyCard;
    this.flightNumber = flightNumber;
    this.ticketNumber = ticketNumber;
    this.cost = cost;
    this.departureDate = departureDate;
    this.departureTime = departureTime;
    this.arrivalDate = arrivalDate;
    this.arrivalTime = arrivalTime;
    this.tax = tax;
    this.penalty = penalty;
    this.ticketId = ticketId;
  }
}

export default {
  name: "TicketsInfo",
  components: {
    VSelect,
    PageName,
    Form,
    VInput,
    Button,
    AccountBadge,
    VFile,
    VFileField,
    Preloader,
    Modal,
    HistoryTickets,
  },
  data() {
    return {
      saveLoading: false,
      returnLoading: false,
      addFileLoading: false,
      fileLoading: false,
      orderLoading: false,
      pointsDataLoading: false,
      isValid: false,
      resetHistorySvg: false,
      files: [],
      tickets: [],
      allTickets: [],
      historyLoading: false,
      currentUser: null,
      currentUserIndex: 0,
      currentPoint: null,
      currentPointIndex: null,
      currentTicketFormSaved: {},
      currentTicketFormChanged: {},
      user: "",
      users: [],
      points: [],
      pointsForms: [],
      formData: new Point(),
      historyDialog: false,
      isHasHistory: false,
      isHasTicketHistory: false,
      commentDialog: {
        isActive: false,
        title: "",
        submit: () => {},
      },
      hasChanges: false,
      portionSize: 4,
      portionNumber: 1,
      ticketStatusesId: null,
      isError: false,
      isCopy: false,
      copyLoading: false,
      copyDate: {},
      cards: [],
      passengerReturn: [],
    };
  },
  async mounted() {
    if (this.orderId) {
      this.orderLoading = true;

      try {
        const res = await getOrderTicketsInfo(this.orderId);
        const { order_passengers: passengers, points } = res.data;

        this.users = passengers.map((pas) => ({
          ...pas.passenger,
          all_tickets: pas.all_tickets,
          modelType: pas.model_passenger.split("\\").slice(-1)[0],
          orderPassengerId: +pas.id,
          history: pas.history,
        }));

        const convertByDirection = (direction, points) => {
          return points
            .filter((point) => point.direction === direction)
            .map((point, i, arr) => {
              let finish_data;
              if (!point.flag_finish) {
                if (arr.at(i + 1)?.start_date && arr.at(i + 1)?.start_time) {
                  finish_data = `${arr.at(i + 1).start_date} ${
                    arr.at(i + 1)?.start_time
                  }`;
                } else if (arr.at(i + 1)?.start_date) {
                  finish_data = arr.at(i + 1).start_date;
                }
              } else {
                finish_data = null;
              }
              return {
                ...point,
                nameTo: !point.flag_finish ? arr.at(i + 1)?.name : null,
                finishAt: finish_data,
                transportAdvance: !point.transport
                  ? arr.at(i + 1)?.transport
                  : null,
                expenseAdvance: !point.expense ? arr.at(i + 1)?.expense : null,
              };
            })
            .slice(0, -1);
        };

        const therePoints = convertByDirection(false, points);
        const backPoints = convertByDirection(true, points);

        this.points = [...therePoints, ...backPoints];
        this.currentUser = this.users[0];

        await this.setPointsData();
        await this.changeHasHistory();
      } catch (err) {
        Promise.reject(err);
      }

      this.setPoint(this.currentPoint, this.currentPointIndex);
      this.orderLoading = false;
      window.addEventListener("keydown", this.setCurrentUserByKeydown);
    }
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.setCurrentUserByKeydown);
  },

  computed: {
    ...mapState("options", ["transportOptions", "expenseOptions"]),
    ...mapState("users", ["activeUser"]),
    statusTicket() {
      switch (this.allTickets[this.currentPointIndex]?.ticket_statuses_id) {
        case 1:
          return { type: "draft", name: "НЕ ПРИОБРЕТЕН" };
        case 2:
          return { type: "success", name: "ПРИОБРЕТЕН" };
        default:
          return { type: "draft", name: "НЕ ПРИОБРЕТЕН" };
      }
    },

    getHistory() {
      return !!this.isHasTicketHistory;
    },
    orderId() {
      return +this.$route.params.id || null;
    },
    leftPageNumber() {
      return (this.portionNumber - 1) * this.portionSize + 1;
    },
    rightPageNumber() {
      return this.portionNumber * this.portionSize;
    },
    portionCount() {
      return Math.ceil(this.points.length / this.portionSize);
    },
    requiredTicketsLength() {
      return this.pointsForms.filter(({ id }) => !!id).length;
    },
    usersCopy() {
      const copy = this.users.filter((user) => this.currentUser.id !== user.id);
      return copy;
    },
    cardOptions() {
      return this.cards;
    },
  },

  methods: {
    changeHasHistory() {
      this.isHasTicketHistory =
        this.allTickets[this.currentPointIndex]?.history;
    },

    uploadTicket(file) {
      if (!this.allTickets[this.currentPointIndex].tickets)
        this.allTickets[this.currentPointIndex].tickets = [];
      if (this.allTickets[this.currentPointIndex].tickets === null)
        this.allTickets[this.currentPointIndex].tickets = [];
      this.allTickets[this.currentPointIndex].tickets = [
        ...this.allTickets[this.currentPointIndex].tickets,
        file,
      ];
      this.files = this.allTickets[this.currentPointIndex].tickets;
      this.isValid = true;
    },

    getTicketInfo(ticketId) {
      const id = ticketId;
      if (id) {
        getTicketInfo(id);
      }
    },

    searchChanges() {
      this.hasChanges = false;

      if (this.allTickets[this.currentPointIndex].tickets?.length)
        this.isValid = true;

      var time = this.allTickets[this.currentPointIndex]?.point?.start_time;
      var timeChange = this.pointsForms[this.currentPointIndex].departureTime;
      if (
        this.allTickets[this.currentPointIndex]?.point?.start_time?.length === 8
      )
        time = this.allTickets[this.currentPointIndex].point.start_time.slice(
          0,
          -3
        );
      if (this.pointsForms[this.currentPointIndex]?.departureTime?.length === 8)
        timeChange = this.pointsForms[
          this.currentPointIndex
        ].departureTime.slice(0, -3);

      this.currentTicketFormChanged = [
        this.pointsForms[this.currentPointIndex].arrivalDate,
        this.pointsForms[this.currentPointIndex].arrivalDate
          ? this.pointsForms[this.currentPointIndex].arrivalTime
            ? this.pointsForms[this.currentPointIndex].arrivalTime
            : "00:00"
          : null,
        this.pointsForms[this.currentPointIndex].cost,
        this.pointsForms[this.currentPointIndex].departureDate,
        this.pointsForms[this.currentPointIndex].departureDate
          ? timeChange
            ? timeChange
            : "00:00"
          : null,
        this.pointsForms[this.currentPointIndex].flightNumber,
        this.pointsForms[this.currentPointIndex].penalty,
        this.pointsForms[this.currentPointIndex].tax,
        this.pointsForms[this.currentPointIndex].ticketNumber,
      ];

      this.currentTicketFormSaved = [
        this.allTickets[this.currentPointIndex].finish_date
          ? simpleDate(this.allTickets[this.currentPointIndex].finish_date)
          : simpleDate(
              this.allTickets[this.currentPointIndex]?.point?.finishAt
            ),
        this.allTickets[this.currentPointIndex].finish_date
          ? onlyTime(this.allTickets[this.currentPointIndex].finish_date)
          : onlyTime(
              this.allTickets[this.currentPointIndex]?.point?.finishAt
            ) || null,
        this.pointsForms[this.currentPointIndex].cost !== ""
          ? this.allTickets[this.currentPointIndex].price || null
          : "",
        simpleDate(this.allTickets[this.currentPointIndex].start_date) ||
          simpleDate(this.allTickets[this.currentPointIndex].point.start_date),
        this.currentTicketFormChanged[4] !== ""
          ? time
            ? time
            : "00:00"
          : null,
        this.pointsForms[this.currentPointIndex].flightNumber !== ""
          ? this.allTickets[this.currentPointIndex].number_flight || null
          : "",
        this.pointsForms[this.currentPointIndex].penalty !== ""
          ? this.allTickets[this.currentPointIndex].penalty || null
          : "",
        this.pointsForms[this.currentPointIndex].tax !== ""
          ? this.allTickets[this.currentPointIndex].tax || null
          : "",
        this.pointsForms[this.currentPointIndex].ticketNumber !== ""
          ? this.allTickets[this.currentPointIndex].number_ticket || null
          : "",
      ];

      this.currentTicketFormChanged.map((item, idx) => {
        if (item !== this.currentTicketFormSaved[idx]) this.hasChanges = true;
      });

      if (this.allTickets[this.currentPointIndex].tickets) {
        this.allTickets[this.currentPointIndex].tickets.map(async (file) => {
          if (file instanceof File) this.hasChanges = true;
        });
      }
    },

    async setUser(user, idx) {
      if (user !== this.currentUser) {
        const valid = await this.$refs.formData.hasValidationErrors([
          "departureDate",
          "departureTime",
          "arrivalDate",
          "arrivalTime",
        ]);
        if (!valid) {
          await this.searchChanges();
          if (this.hasChanges && this.isValid) {
            await this.saveAllChanges(this.currentPointIndex);
          } else if (this.hasChanges && !this.isValid) {
            this.isError = true;
            return;
          }
          this.currentUser = user;
          this.currentUserIndex = idx;
          this.currentPointIndex = null;
          await this.setPointsData();
          this.files = this.allTickets[0].tickets;
          await this.changeHasHistory();
        }
      }
    },

    async setPoint(point, index) {
      const valid = await this.$refs.formData.hasValidationErrors([
        "departureDate",
        "departureTime",
        "arrivalDate",
        "arrivalTime",
      ]);
      if (!valid) {
        await this.searchChanges();
        if (this.hasChanges && this.isValid) {
          await this.saveAllChanges(this.currentPointIndex);
        } else if (this.hasChanges && !this.isValid) {
          this.isError = true;
          return;
        }
        const ticket = this.allTickets[index];
        this.currentPoint = point;
        this.currentPointIndex = index;
        this.files = this.allTickets[this.currentPointIndex].tickets;
        this.allTickets[this.currentPointIndex].ticket_statuses_id =
          ticket && ticket.ticket_statuses_id;
        await this.changeHasHistory();
      }
    },

    async setPointsData() {
      this.resetHistorySvg = false;
      this.pointsDataLoading = true;

      try {
        const res = await getAllTicketsInfo(
          this.orderId,
          this.currentUser.id,
          this.currentUser.modelType
        );

        this.resetHistorySvg = true;
        const newPointsForms = [];
        this.tickets = [];

        this.currentPoint = this.points[0];
        this.currentPointIndex = 0;

        this.points.forEach(
          ({
            id,
            start_date: startDate,
            start_time: start_time,
            finishAt: pointFinishAt,
            transport: transportAdvance,
            expense: expenseAdvance,
          }) => {
            const {
              ticketStatusesId = this.allTickets[this.currentPointIndex]
                ?.ticket_statuses_id,
              expense,
              transport,
              loyalty_card,
              number_flight,
              number_ticket,
              price,
              start_date,
              finish_date,
              tax,
              penalty,
              tickets,
              id: ticketId,
            } = [...Object.values(res?.data)]?.find(({ point }) => {
              return id === point.id;
            }) || {};

            let time = null;
            if (pointFinishAt) {
              if (pointFinishAt.includes(" ")) {
                time = pointFinishAt.split(" ")[1].substring(0, 5);
              } else {
                time = null;
              }
            }

            newPointsForms.push(
              new Point(
                ticketStatusesId,
                expense || expenseAdvance,
                transport || transportAdvance,
                loyalty_card,
                number_flight,
                number_ticket,
                price,
                simpleDate(start_date) || convertDate(startDate),
                onlyTime(start_date) || start_time,
                simpleDate(finish_date) || simpleDate(pointFinishAt),
                onlyTime(finish_date) || time,
                tax,
                penalty,
                ticketId
              )
            );
            if (tickets) {
              this.files = tickets;
            }
          }
        );

        this.allTickets = this.setAllTickets([...Object.values(res.data)]);
        this.pointsForms = newPointsForms;
      } catch (err) {
        Promise.reject(err);
      }

      await getUserCard(this.currentUser.id).then((res) => {
        this.cards = res.data;
      });

      this.pointsDataLoading = false;
    },

    hasFieldContent() {
      this.isValid = false;
      const listForValidate = [
        "ticketNumber",
        "tax",
        "penalty",
        "cost",
        "flightNumber",
      ];
      for (const [key, value] of Object.entries(this.formData)) {
        if (listForValidate.includes(key)) {
          if (value) {
            this.isValid = true;
          }
        }
      }
    },

    async saveAllChanges(index = null) {
      if (index === null) index = this.currentPointIndex;

      if (
        this.allTickets[index].tickets === null ||
        !this.allTickets[index].tickets?.length
      ) {
        await this.hasFieldContent();
      }

      if (
        !this.$refs.formData.hasValidationErrors([
          "departureDate",
          "departureTime",
          "arrivalDate",
          "arrivalTime",
        ]) &&
        this.isValid
      ) {
        this.saveLoading = true;
        try {
          const form = this.pointsForms[index];
          const trimCost = form?.cost;
          const trimPenalty = form?.penalty;
          const startDate = form?.departureDate
            ? parseDate(`${form?.departureDate} ${form?.departureTime}`)
            : "";
          const endDate = form?.arrivalDate
            ? parseDate(`${form?.arrivalDate} ${form?.arrivalTime}`)
            : "";

          this.formData.ticketStatusesId = 2;
          var tickets = null;

          if (form?.ticketId) {
            const response = await UpdateTicket(
              2,
              form?.expense?.id,
              form?.transport?.id,
              form?.loyaltyCard?.id,
              form?.ticketId,
              form?.flightNumber,
              form?.ticketNumber,
              trimCost,
              startDate,
              endDate,
              this.currentUser?.orderPassengerId,
              this.points[index]?.id,
              form?.tax,
              trimPenalty
            );
            this.formData.ticketId = response?.data?.id;
            tickets = this.allTickets[index].tickets;
            this.allTickets[index] = response.data;
            this.allTickets[index].tickets = tickets;
            if (tickets) {
              tickets.map(async (file) => {
                if (file instanceof File) {
                  const res = await AddTicketFile(
                    response?.data?.id,
                    file
                  ).finally(() => {
                    this.$root.popup("Билет прикреплен", null, "success");
                  });
                  this.allTickets[index].tickets = res?.data;
                }
              });
            }
          } else {
            const response = await CreateTicket(
              2,
              form?.expense?.id,
              form?.transport?.id,
              form?.loyaltyCard?.id,
              form?.flightNumber,
              form?.ticketNumber,
              trimCost,
              startDate,
              endDate,
              this.currentUser?.orderPassengerId,
              this.points[index]?.id,
              form?.tax,
              trimPenalty
            );
            this.formData.ticketId = response?.data?.id;
            tickets = this.allTickets[index].tickets;
            this.allTickets = this.addNewTicket(
              [...this.allTickets],
              response.data
            );
            this.allTickets[index].tickets = tickets;
            if (tickets) {
              tickets.map(async (file) => {
                if (file instanceof File) {
                  const res = await AddTicketFile(
                    response?.data?.id,
                    file
                  ).finally(() => {
                    this.$root.popup("Билет прикреплен", null, "success");
                  });
                  this.allTickets[index].tickets = res?.data;
                }
              });
            }
          }
          // После сохранения меняем статус на приобретен
          this.allTickets[index].ticket_statuses_id = 2;
          form.ticketStatusesId = 2;
          this.$root.popup("Сохранено", null, "success");
        } catch (err) {
          Promise.reject(err);
        }
        this.saveLoading = false;
        index = this.currentPointIndex;
      }
    },

    async removeFile(file, index) {
      if (file instanceof File) {
        this.allTickets[this.currentPointIndex].tickets = this.allTickets[
          this.currentPointIndex
        ].tickets.filter((_, idx) => idx !== index);
      } else {
        this.fileLoading = true;
        try {
          await removeFile(
            this.allTickets[this.currentPointIndex].tickets[index].id
          );
          this.allTickets[this.currentPointIndex].tickets = this.allTickets[
            this.currentPointIndex
          ].tickets.filter((_, idx) => idx !== index);
        } catch (err) {
          Promise.reject(err);
        }
        this.fileLoading = false;
      }
      this.files = this.allTickets[this.currentPointIndex].tickets;
    },

    setCurrentUserByKeydown(e) {
      if (e.keyCode == "38" && this.currentUserIndex > 0) {
        e.preventDefault();
        this.currentUserIndex -= 1;
        this.setUser(this.users[this.currentUserIndex]);
      } else if (
        e.keyCode == "40" &&
        this.users.length - 1 > this.currentUserIndex
      ) {
        e.preventDefault();
        this.currentUserIndex += 1;
        this.setUser(this.users[this.currentUserIndex]);
      }
    },

    checkValidDate(isValid) {
      !!isValid &&
        this.$root.popup(
          "Ошибка",
          "Введите полностью дату\n и время",
          "error",
          "alert"
        );
    },

    openReturnOrderModal(type) {
      const changeStatus = async () => {
        this.returnLoading = true;
        if (this.allTickets[this.currentPointIndex].tickets) {
          this.allTickets[this.currentPointIndex].tickets.map(async (file) => {
            if (!(file instanceof File)) await removeFile(file?.id);
          });
        }
        this.allTickets[this.currentPointIndex].tickets = [];
        this.files = this.allTickets[this.currentPointIndex].tickets;
        this.commentDialog.isActive = false;
        const id = this.formData.ticketId;
        const historyTicket = {
          path: `${this.currentPoint.name} - ${this.currentPoint.nameTo}`,
          expenses: this.formData.expense?.name,
          transport: this.formData.transport?.name,
          loyalty_card: this.formData.loyaltyCard?.card_number,
          number_flight: this.formData.flightNumber,
          number_ticket: this.formData.ticketNumber,
          tax: this.formData.tax,
          price: this.formData.cost,
          penalty: this.formData.penalty,
          start_date:
            this.formData.departureDate + " " + this.formData.departureTime,
          finish_date:
            this.formData.arrivalDate + " " + this.formData.arrivalTime,
        };

        if (this.activeUser.surname !== null) {
          this.user = this.activeUser?.surname + " " + this.activeUser.name;
        } else {
          this.user = this.activeUser.name;
        }

        await setStatusReturn(id, historyTicket)
          .then((res) => {
            if (this.allTickets[this.currentPointIndex]) {
              this.allTickets[this.currentPointIndex].history = [
                ...res.data.history,
              ];
              this.allTickets[this.currentPointIndex].ticket_statuses_id = 1;
            }
          })
          .finally(() => {
            this.isHasHistory = true;
            this.isValid = false;
            this.formData.flightNumber = "";
            this.formData.ticketNumber = "";
            this.formData.tax = "";
            this.formData.cost = "";
            this.formData.penalty = "";
            this.formData.ticketStatusesId = 1;
            this.users[this.currentUserIndex].history = true;
            this.returnLoading = false;
          });
        this.changeHasHistory();
      };

      this.commentDialog = {
        title: type === "return" ? "Возврат" : "Обмен",
        submit: changeStatus,
        isActive: true,
      };
    },

    addNewTicket(array, point) {
      let ticket = array.find((el) => el.point.id === point.point_id);
      const idx = array.findIndex((el) => el.point.id === point.point_id);

      ticket = { ...ticket, ...point };
      array.splice(idx, 1, ticket);

      return array;
    },

    setAllTickets(array) {
      let tickets = [...this.points].map((item) => ({
        point: item,
        ticket_statuses_id: 1,
      }));

      tickets.forEach((item, idx) => {
        const ticket = array.find((el) => el?.point?.id === item.point.id);
        if (ticket) {
          tickets[idx] = ticket;
        }
      });

      return tickets;
    },

    openCopyModal() {
      this.isCopy = true;
    },

    async copyNumberFlights() {
      this.copyLoading = true;
      let passengers = [];
      this.copyDate.passengersCopy.forEach((pas) => {
        let model = "App\\Models\\User\\User";
        if (pas.modelType === "Passenger")
          model = "App\\Models\\Passenger\\Passenger";
        passengers.push({
          id: pas.id,
          modelType: model,
        });
      });
      this.currentPoint;
      let startDate = this.formData.departureDate
        ? parseDate(
            `${this.formData.departureDate} ${this.formData?.departureTime}`
          )
        : "";
      let finishDate = this.formData.arrivalDate
        ? parseDate(
            `${this.formData.arrivalDate} ${this.formData?.arrivalTime}`
          )
        : "";
      await copyNumberFlights(
        this.orderId,
        this.currentPoint.id,
        passengers,
        this.formData.flightNumber,
        startDate,
        finishDate
      ).then((res) => {
        this.copyLoading = false;
        this.isCopy = false;
        console.log(res);
      });
    },

    selectPassengerReturn(data) {
      this.passengerReturn = data;
    },
  },

  beforeRouteLeave(to, from, next) {
    this.searchChanges();
    if (!this.hasChanges) {
      next();
    } else {
      this.$root.confrim(
        "Изменения не сохранены. Вы точно хотите покинуть эту страницу?",
        () => next(),
        "Да"
      );
    }
  },

  watch: {
    formData: {
      handler(value) {
        this.hasFieldContent();
        this.pointsForms[this.currentPointIndex] = new Point(
          value?.ticketStatusesId,
          value?.expense,
          value?.transport,
          value?.loyaltyCard,
          value?.flightNumber,
          value?.ticketNumber,
          value?.cost,
          value?.departureDate,
          value?.departureTime,
          value?.arrivalDate,
          value?.arrivalTime,
          value?.tax,
          value?.penalty,
          value?.ticketId
        );
      },
      deep: true,
    },
    currentPointIndex(i) {
      if (!isNaN(+i) && i !== null) {
        const {
          ticketStatusesId,
          expense,
          transport,
          loyaltyCard,
          flightNumber,
          ticketNumber,
          cost,
          departureDate,
          departureTime,
          arrivalDate,
          arrivalTime,
          tax,
          penalty,
          ticketId,
        } = this.pointsForms[i] || {};
        this.formData = new Point(
          ticketStatusesId,
          expense,
          transport,
          loyaltyCard,
          flightNumber,
          ticketNumber,
          cost,
          departureDate,
          departureTime,
          arrivalDate,
          arrivalTime,
          tax,
          penalty,
          ticketId
        );
        this.$refs.formData.resetForm();
      }
    },
    tickets: {
      handler(tickets) {
        if (tickets) {
          this.currentUser.all_tickets = tickets.every((ticket) => ticket);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  display: flex;
  flex-direction: row;
  width: 100%;

  .page__block {
    width: 100%;
    background: #f1f6f9;
    border-radius: 4px;
    padding: 32px;
    //height: 753px;
    // height: auto;

    @media screen and (max-width: 1500px) {
      padding: 20px;
    }

    &:nth-child(2) {
      max-width: 594px;
      // width: 41%;
    }

    &:nth-child(1) {
      max-width: 560px;
      // width: 41%;
    }

    h3 {
      margin-bottom: 24px;
    }

    .passengers {
      max-height: 580px;
      min-height: calc(100% - 48px);

      .passengers__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 9px;
        transition: all 0.2s;
        cursor: pointer;

        &.active {
          background: #ffffff;
          border-radius: 4px;
          box-shadow: 0 4px 4px rgba(0, 32, 51, 0.04),
            0 8px 24px rgba(0, 32, 51, 0.12);
          border: 1px solid $dark-blue;
        }
      }
    }

    .points__panel {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 20px;
      padding-bottom: 14px;
      border-bottom: 1px solid $gray;
      color: $dark-gray;
      white-space: nowrap;

      .points__panel-block {
        display: flex;
      }

      .points__panel-icon {
        fill: none;
        stroke: $gray;

        &:first-of-type {
          transform: rotate(180deg);
          margin-right: 15px;
        }

        &.active {
          stroke: $dark-blue;
          cursor: pointer;
        }
      }

      .points__panel-item {
        margin-right: 20px;
        cursor: pointer;
        transition: 0.2s;

        &:hover {
          color: $blue;
        }

        &.active {
          position: relative;
          color: $black;

          &::after {
            content: "";
            position: absolute;
            bottom: -14px;
            display: flex;
            width: 100%;
            border: 2px solid $blue;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
          }
        }
      }

      &::-webkit-scrollbar {
        height: 5px;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(0, 66, 105, 0.06);
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 66, 105, 0.24);
        border-radius: 10px;
      }
    }

    .points__way {
      display: flex;
      color: $dark-gray;
      fill: $dark-gray;
      margin-bottom: 20px;

      &-town {
        color: $black;
      }

      .points__way-icon {
        transform: rotate(180deg);
        margin: 0 12px;
      }
    }

    .ticket__form {
      row-gap: 12px;
      // height: 496px;

      .double-fields {
        grid-template-columns: 62% 1fr;
      }

      .ticket__form-file {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        min-height: 35px;
        width: 100%;
        margin: 8px 0 14px;
        position: relative;

        .clear-icon {
          cursor: pointer;

          &:hover {
            fill: $red;
          }
        }

        .preloader {
          // position: absolute;
          // right: 0px;
          min-height: 20px;
          max-width: 70px;
        }
      }
    }
  }
}

.user_return-ticket {
  margin-right: 10px;

  &:hover path {
    fill: #006fba;
  }
}

.success-icon {
  fill: none;
  stroke: white;
}

.status {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 0 8px;
  height: 24px;
  color: white;
  font-weight: bold;
  font-size: 12px;
  max-width: 130px;
  white-space: nowrap;
  text-transform: uppercase;
  margin-left: auto;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.ticket-log {
  &__link {
    display: flex;
    cursor: pointer;
    color: #0078d2;

    &:hover {
      color: $blue;

      path {
        fill: $blue;
      }
    }
  }
  &__icon {
    margin-right: 12px;
  }
}

.page .page__block .passengers .passengers__item.active {
  box-shadow: none;
}

.page__block--tickets {
  border: 1px solid #b8cad5;
  background: transparent !important;

  @media screen and (max-width: 1500px) {
    margin-left: 12px !important;
  }
}

.success {
  background: $green;
  // width: 96px;
}

.danger {
  background: $red;
  // width: 80px;
}

.warn {
  background: $orange;
  // width: 77px;
}

.normal {
  background: $blue;
  // width: 60px;
}

.draft {
  background: $light-gray;
  color: $light-black;
  // width: 80px;
}
.center {
  text-align: center;
}
</style>
